import { Route } from 'react-router-dom'

// routes
import { PRIVATE_ROUTES } from '../routes'

// modules
import PermissionRoutes from '../modules/permissionRoutes'
import ProjectDetail from '../modules/projects/projectDetail'
import BrowseProjectsPage from '../modules/projects/browseProjects.index'

// constants
import Clients from '../modules/clients'
import Talent from '../modules/talent'
import Home from '../modules/home'
import Reporting from '../modules/reporting'
import CO7 from '../modules/co7'
import StoryMapMigration from '../modules/storyMapMigration'
import { canAccessStoryMapMigration } from '../modules/storyMapMigration/storyMapMigration.utils'
import TestRunMain from '../modules/testRun'
import TestRunDetails from '../modules/testRun/components/testRun/details/TestRunDetails'
import { canViewClients, canViewReporting, canViewTalent } from './reportsPermission'

// CLIENTS ROUTE (Only for Super Admin)
const CLIENTS_ROUTE = [
    <Route path={PRIVATE_ROUTES.clients} element={<Clients />} />,
]

const TALENT_ROUTE = [
    <Route path={PRIVATE_ROUTES.talent} element={<Talent />} />,
]

// HOME ROUTE (Everyone)
const HOME_ROUTE = [<Route path={PRIVATE_ROUTES.home} element={<Home />} />]

const REPORTING_ROUTE = [
    <Route path={`${PRIVATE_ROUTES.reporting}/*`} element={<Reporting />} />,
]

const CO7_ROUTE = [<Route path={PRIVATE_ROUTES.co7} element={<CO7 />} />]

const STORY_MAP_MIGRATION_ROUTE = [
    <Route
        path={PRIVATE_ROUTES.storyMapMigration}
        element={<StoryMapMigration />}
    />,
]

const TEST_RUN_ROUTE = [
    <Route path={PRIVATE_ROUTES.testRun} element={<TestRunMain />} />,
    <Route
        path={PRIVATE_ROUTES.testRunDetails}
        element={<TestRunDetails />}
    />,
]

// PROJECTS LIST ROUTE
const PROJECTS_ROUTE = [
    <Route
        path={PRIVATE_ROUTES.projects.root}
        element={<BrowseProjectsPage />}
    />,
]

// PROJECT DETAIL ROUTE
const PROJECT_DETAIL_ROUTE = [
    <Route
        path={PRIVATE_ROUTES.projects.projectId(':id')}
        element={
            <PermissionRoutes keyPath={PRIVATE_ROUTES.projects.root}>
                <ProjectDetail />
            </PermissionRoutes>
        }
    />,
    <Route
        path={PRIVATE_ROUTES.projects.projectIdView(':id', ':view')}
        element={
            <PermissionRoutes keyPath={PRIVATE_ROUTES.projects.root}>
                <ProjectDetail />
            </PermissionRoutes>
        }
    />,
    <Route
        path={PRIVATE_ROUTES.projects.projectIdViewTask(':id', ':view', ':taskId')}
        element={
            <PermissionRoutes keyPath={PRIVATE_ROUTES.projects.root}>
                <ProjectDetail />
            </PermissionRoutes>
        }
    />,
    // <Route path={PRIVATE_ROUTES.changePassword} element={<ChangePassword />} />,
]

// CHECK PERMISSION AND ASSIGN ROUTES
export const checkRoutePermission = (
    userProfile,
    clientModalProjectsListData,
    clientModalTotalProjects = 0
) => {
    const routes = []
    const isSuperOrExistingUser = Boolean(
        userProfile?.isSuperAdmin || userProfile?.isExistingUser
    )

    if (canViewClients(userProfile)) {
        routes.push(...CLIENTS_ROUTE)
    }

    if (canViewTalent(userProfile)) {
        routes.push(...TALENT_ROUTE)
    }

    if (canViewReporting(userProfile)) {
        routes.push(...REPORTING_ROUTE)
    }

    if (userProfile?.isSupportUser) {
        routes.push(...CO7_ROUTE)
    }

    if (canAccessStoryMapMigration(userProfile)) {
        routes.push(...STORY_MAP_MIGRATION_ROUTE)
    }
    if (userProfile?.isExistingUser) {
        routes.push(...TEST_RUN_ROUTE)
    }

    routes.push(...HOME_ROUTE)

    routes.push(...PROJECT_DETAIL_ROUTE)

    if (
        isSuperOrExistingUser ||
        Number(clientModalTotalProjects || clientModalProjectsListData?.length || 0) >
            5
    ) {
        routes.push(...PROJECTS_ROUTE)
    }

    return routes.length > 0 ? routes : undefined
}
